import { disableInputs, enableInputs, findInputs } from "#/admin/legacy/forms/input-ownership.js";
import { setTargetVisibility } from "#/admin/legacy/forms/target-visibility.js";

const CONTAINER_SELECTOR = '[data-behaviour~="show-on-click-container"]';
const TRIGGER_SELECTOR = '[data-behaviour~="show-on-click"]';

function toggleElements(event) {
  const trigger = event.target.closest(TRIGGER_SELECTOR);
  const container = trigger?.closest(CONTAINER_SELECTOR);

  if (!container) {
    return;
  }

  const { scope, target } = trigger.dataset;

  for (const element of container.querySelectorAll(`[data-show-on-click-scope="${CSS.escape(scope)}"]`)) {
    disableInputs(findInputs(element), scope);
    setTargetVisibility(element, false);
  }

  for (const element of container.querySelectorAll(`[data-show-on-click-target="${CSS.escape(target)}"]`)) {
    enableInputs(findInputs(element), scope);
    setTargetVisibility(element, true);
  }
}

document.addEventListener("click", toggleElements);
